/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectTaskRef } from './projectTaskRef';
import { CompanyBrandRef } from './companyBrandRef';
import { ProjectRef } from './projectRef';
import { CompanyRef } from './companyRef';


export interface Project { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    accessKeys: Array<string>;
    name: string;
    tasks?: Array<ProjectTaskRef>;
    agency: CompanyRef;
    client: CompanyRef;
    brand: CompanyBrandRef;
    parentId: ProjectRef;
    childIds: Array<ProjectRef>;
    type: string;
    startDate: string;
    deadline: string;
    parentStartDate?: string;
    parentDeadline?: string;
    description?: string;
    projectNumber?: string;
    validProjectNumber?: boolean;
    priority: Project.PriorityEnum;
    clientRefNumber?: string;
    invoiceClient?: CompanyRef;
    status?: Project.StatusEnum;
    confidential?: boolean;
    assets?: Array<string>;
    spMakeFoldersKeys?: Array<string>;
    pathToFolderParts?: Array<string>;
    /**
     * I am following this project to get notifications
     */
    following: boolean;
}
export namespace Project {
    export type PriorityEnum = 'low' | 'normal' | 'high' | 'urgent';
    export const PriorityEnum = {
        Low: 'low' as PriorityEnum,
        Normal: 'normal' as PriorityEnum,
        High: 'high' as PriorityEnum,
        Urgent: 'urgent' as PriorityEnum
    };
    export type StatusEnum = 'Draft' | 'Created' | 'In progress' | 'Billing' | 'Closed';
    export const StatusEnum = {
        Draft: 'Draft' as StatusEnum,
        Created: 'Created' as StatusEnum,
        InProgress: 'In progress' as StatusEnum,
        Billing: 'Billing' as StatusEnum,
        Closed: 'Closed' as StatusEnum
    };
}


